import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { message, Button, Modal } from 'antd';
import { document } from 'src/api';
import * as React from 'react';
import { history } from 'kts-platform-frame/routes';

class ModulesAction extends ActionBasic<ModulesState> {
    /** 拒绝 弹框打开/关闭 */
    public refuseM = (refuseType?: string) => {
        this.modulesState.refuseType = refuseType ? refuseType : '';
        this.modulesState.refuseInputNum = 0;
        this.modulesState.refuseM = !this.modulesState.refuseM;
        this.setModulesState(this.modulesState);
    }
    /** 拒绝理由验证长度 */
    public checkLength = (e: any) => {
        this.modulesState.refuseInputNum = e.target.value.length;
        this.setModulesState(this.modulesState);
    }
    /**
     * 更新文档状态
     */
    public updataDocumentStatus = async (status: string, content?: string) => {
        const param = {
            documentUUID: this.modulesState.documentUUID,
            status: status,
            message: content,
            isCheckout: true,
        };
        const reData = await document.invoiceStatusUpdate(this, param);
        if (!reData.er) {
            message.success("操作成功");
            window.location.reload();
            // history.push(`/workbench/platform/document/invoiceDetail/${this.modulesState.documentUUID}`);

        }
    }
    /**
     *  拒绝 和 接受 按钮
     */
    public allowedTargetStatus = (id: string, status: any) => {
        this.modulesState.documentUUID = id;
        // let allowedTargetStatus = status || [];
        let temp = [];
        status.forEach(element => {
            switch (element) {
                case 'REJECTED':
                    temp.push(
                        <Button
                            key={element}
                            onClick={() => this.refuseM('REJECTED')}
                            className="kts-but-default"
                            style={{ marginRight: '12px' }
                            }
                        >
                            拒绝
                        </Button>
                    );
                    break;
                case 'ACCEPTED':
                    temp.push(
                        <Button
                            key={element}
                            className="kts-but-general"
                            onClick={() => this.updataDocumentStatus('ACCEPTED')}
                            style={{ marginRight: '12px' }}
                        >
                            接受
                        </Button>
                    );
                    break;
                case 'CANCEL_REJECTED':
                    temp.push(
                        <Button
                            key={element}
                            onClick={() => this.refuseM('CANCEL_REJECTED')}
                            className="kts-but-default"
                            style={{ marginRight: '12px' }}
                        >
                            拒绝作废
                        </Button>
                    );
                    break;
                case 'CANCELED':
                    temp.push(
                        <Button
                            key={element}
                            className="kts-but-general"
                            onClick={() => this.updataDocumentStatus('CANCELED')}
                            style={{ marginRight: '12px' }}
                        >
                            接受作废
                            {/* {this.modulesState.isSenderParty ? '作废' : '接受作废'} */}
                        </Button>
                    );
                    break;
                case 'SEND':
                    temp.push(
                        <Button
                            key={element}
                            className="kts-but-general"
                            onClick={() => this.send(id)}
                            style={{ marginRight: '12px' }}
                        >
                            发送
                        </Button>
                    );
                    break;
                default:
                    break;
            }
        });
        return temp;
    }
    /** 发送 */
    public send = (documentUUID) => {
        this.checkDocument({ documentUUID: documentUUID }).then(res => {
            if (!res.er) {
                const fieldErrors: any = res.res;
                if (res.res && fieldErrors && fieldErrors.length > 0) {
                    this.showErrorInfos(fieldErrors);
                } else {
                    this.documentSend(documentUUID);
                }
            }
        });
    }
    /** 发送之前验证文档是否符合规则 */
    public checkDocument = async (param: any) => {
        const res = await document.checkDocumentByUuid(this, param);
        return res;
    }
    /** 错误信息提示 */
    public showErrorInfos = (fieldErrors: any[]) => {
        Modal.error({
            title: '发送失败',
            content: '当前单据包含不符合单据规范的内容',
        });
    }
    /** 发送  */
    public documentSend = async (documentUUID: string) => {
        const param = {
            documentUUID: this.modulesState.documentUUID,
        };
        const reData = await document.documentSend(this, param);
        if (!reData.er) {
            message.success("发送成功");
            window.location.reload();
            // history.push(`/workbench/platform/document/invoiceDetail/${documentUUID}`);
        }
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/Modules.Action.tsx